import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import BasicAuth from '../../../../../libraries/Images/basicAuth.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="openbrowser">
                1.&nbsp;<span className="material-symbols-outlined">web_asset</span>&nbsp;{translate('openbrowser')}
            </Typography>
            <p><strong>{translate('openbrowser')}</strong> là một hành động được sử dụng trong hầu hết mọi quy trình làm việc. Khởi chạy trình duyệt (Chromium) và mở trang web được chỉ định. Kết quả đầu ra sẽ là địa chỉ web của trình duyệt đã khởi chạy.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và dùng để chỉ định đối tượng trình duyệt cho những hành động khác.</td>
                                <td>$browser_1</td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ của trang web muốn mở.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('windowsize')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là kích thước màn hình khi khởi động trình duyệt.</td>
                                <td>1280 x 1024</td>
                            </tr>
                            <tr>
                                <td>{translate('language')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ngôn ngữ trình duyệt.</td>
                                <td>English</td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthusername')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên đăng nhập trong hộp thoại (xem số ❶ ở phần bổ sung).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthpassword')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là mật khẩu trong hộp thoại (xem số ❷ ở phần bổ sung).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động nhấp vào nút của hộp thoại, nếu công tắc <trong>Accept dialog</trong> được bật (true) thì sẽ nhấp vào nút <strong>{translate('signin')}</strong> (xem số ❸ ở phần bổ sung).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>Trường hợp trình duyệt hiện ra hộp thoại.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>ws://127.0.0.1:58580/devtools/browser/e490bb1b-e478-48c2-a8e1-7f5e2da46e0</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="typetext">
                2.&nbsp;<span className="material-symbols-outlined">text_fields</span>&nbsp;{translate('typetext')}
            </Typography>
            <p><strong>{translate('typetext')}</strong> là một hành động nhập văn bản vào thành phần được chỉ định trong trình duyệt. Thay vì đặt một giá trị trong trường nhập liệu, đây là thao tác nhập từng văn bản một như thể con người nhập văn bản đó.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn nhập văn bản trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản muốn nhập.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clearvalue')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động xoá hết văn bản, nếu công tắc <strong>{translate('clearvalue')}</strong> được bật (true) thì văn bản có trước đó sẽ bị xoá và thay thế bằng văn bản mới.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.username</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>support@rpa-cloud.io</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="typepassword">
                3.&nbsp;<span className="material-symbols-outlined">password</span>&nbsp;{translate('typepassword')}
            </Typography>
            <p><strong>{translate('typepassword')}</strong> hoạt động giống như {translate('typetext')}, nhưng mật khẩu sẽ được ẩn.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn nhập mật khẩu trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Password<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là mật khẩu muốn nhập.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clearvalue')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động xoá hết văn bản, nếu công tắc <strong>{translate('clearvalue')}</strong> được bật (true) thì văn bản có trước đó sẽ bị xoá và thay thế bằng văn bản mới.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.password</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Password</span>
                            <div>Abc123#</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="click">
                4.&nbsp;<span className="material-symbols-outlined">ads_click</span>&nbsp;{translate('click')}
            </Typography>
            <p><strong>{translate('click')}</strong> là hành động nhấp vào phần tử được chỉ định trong trình duyệt.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn nhấp vào trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('waitfornavigation')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động chờ điều hướng của trình duyệt, nếu công tắc <strong>{translate('waitfornavigation')}</strong> được bật (true) thì trình duyệt sẽ chờ sự kiện này xảy ra một cách rõ ràng rồi tiếp tục thực hiện hành động tiếp theo.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>Accept dialog</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động nhấp vào nút của hộp thoại, nếu công tắc <strong>Accept dialog</strong> được bật (true) thì sẽ nhấp vào nút <strong>{translate('signin')}</strong> (xem số ❸ ở phần bổ sung).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>Trường hợp trình duyệt hiện ra hộp thoại.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>button.signin</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="selectoption">
                5.&nbsp;<span className="material-symbols-outlined">checklist</span>&nbsp;{translate('selectoption')}
            </Typography>
            <p><strong>{translate('selectoption')}</strong> là hành động chọn danh sách tùy chọn theo tên hiển thị (văn bản bên trong) của nó.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của danh sách tùy chọn trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là tên hiển thị (văn bản bên trong) của tùy chọn.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>select.gender</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>male</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="keyboardpress">
                6.&nbsp;<span className="material-symbols-outlined">keyboard_command_key</span>&nbsp;{translate('keyboardpress')}
            </Typography>
            <p><strong>{translate('keyboardpress')}</strong> là các hành động thao tác với bàn phím.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('keyboards')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên của phím trên bàn phím. Xem <a href="https://github.com/puppeteer/puppeteer/blob/1ecb6e3f19c970257626d58ea2fa5323195fc1f2/src/common/USKeyboardLayout.ts" target="_blank">tại đây</a> để biết danh sách các tên phím có sẵn.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <div>ArrowLeft,Enter</div>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('keyboards')}</span>
                            <div>["ArrowLeft", "Enter"]</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloadfile">
                7.&nbsp;<span className="material-symbols-outlined">file_download</span>&nbsp;{translate('downloadfile')}
            </Typography>
            <p><strong>{translate('downloadfile')}</strong> là hành động tải tệp xuống, tệp sẽ được lưu trong kho lưu trữ.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và là địa chỉ lưu tệp tải tệp xuống.</td>
                                <td>$file_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('actionsfordownload')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là hành động để kích hoạt việc tải tệp xuống. Lưu ý nếu chọn hành động là <strong>{translate('selectoption')}</strong> thì phải nhập giá trị <strong>{translate('text')}</strong>.</td>
                                <td>{translate('click')}</td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn kích hoạt việc tải tệp xuống trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên hiển thị (văn bản bên trong) của tùy chọn.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$file_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('actionsfordownload')}</span>
                            <div>Click</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>button.download</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/data.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="uploadfile">
                8.&nbsp;<span className="material-symbols-outlined">file_upload</span>&nbsp;{translate('uploadfile')}
            </Typography>
            <p><strong>{translate('uploadfile')}</strong> là hành động tải tệp lên trình duyệt từ kho lưu trữ.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn tải tệp lên trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ lưu ở kho lưu trữ của tệp muốn tải lên.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.upload</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/data.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gettext">
                9.&nbsp;<span className="material-symbols-outlined">text_increase</span>&nbsp;{translate('gettext')}
            </Typography>
            <p><strong>{translate('gettext')}</strong> là hành động lấy tất cả văn bản trong phần tử được chỉ định trong trình duyệt.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$text_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn lấy văn bản. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>p.google</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Google is a technology company</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="clickpoint">
                10.&nbsp;<span className="material-symbols-outlined">my_location</span>&nbsp;{translate('clickpoint')}
            </Typography>
            <p><strong>{translate('clickpoint')}</strong> là hành động nhấp vào vị trí được chỉ định bởi tọa độ x,y. Nếu có bộ chọn thì tọa độ x, y có thể được chỉ định với phía trên bên trái của phần tử được bộ chọn chỉ định làm điểm tham chiếu.</p>
            <p>Bạn có thể cài đặt tiện ích lấy tọa độ x, y <a href="https://chrome.google.com/webstore/detail/coordinates/bpflbjmbfccblbhlcmlgkajdpoiepmkd" target="_blank">tại đây</a>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn nhấp vào trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('coordinatex')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là tọa độ X (đơn vị là pixel).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('coordinatey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là tọa độ Y (đơn vị là pixel).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('waitfornavigation')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động chờ điều hướng của trình duyệt, nếu công tắc <strong>{translate('waitfornavigation')}</strong> được bật (true) thì trình duyệt sẽ chờ sự kiện này xảy ra một cách rõ ràng rồi tiếp tục thực hiện hành động tiếp theo.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>Accept dialog</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động nhấp vào nút của hộp thoại, nếu công tắc <strong>Accept dialog</strong> được bật (true) thì sẽ nhấp vào nút <strong>{translate('signin')}</strong> (xem số ❸ ở phần bổ sung).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>Trường hợp trình duyệt hiện ra hộp thoại.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('coordinatex')}</span>
                            <div>200</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('coordinatey')}</span>
                            <div>500</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="takescreenshot">
                11.&nbsp;<span className="material-symbols-outlined">panorama</span>&nbsp;{translate('takescreenshot')}
            </Typography>
            <p><strong>{translate('takescreenshot')}</strong> là hành động lưu màn hình trình duyệt dưới dạng ảnh.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và là địa chỉ lưu hình ảnh.</td>
                                <td>$screenshot_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clip')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định khu vực cắt hình ảnh chụp màn hình (trái, trên cùng, chiều rộng, chiều cao). Các giá trị ngăn cách nhau bởi dấu phẩy. Nếu để trống sẽ chụp toàn màn hình.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$screenshot_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('clip')}</span>
                            <div>0,100,500,500</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/149a0611.png</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="pagepdf">
                12.&nbsp;<span className="material-symbols-outlined">panorama</span>&nbsp;{translate('pagepdf')}
            </Typography>
            <p><strong>{translate('pagepdf')}</strong> là hành động xuất trang được hiển thị thành PDF để in.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và là địa chỉ lưu tệp PDF.</td>
                                <td>$pdf_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là kích thước giấy in.</td>
                                <td>A4</td>
                            </tr>
                            <tr>
                                <td>{translate('scale')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tỷ lệ in.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('pageranges')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là sự chỉ định những trang được in. Để trống để in tất cả các trang. Bạn có thể chỉ định các phạm vi bằng cách sử dụng dấu - và nhiều phạm vi được phân tách bằng dấu phẩy.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>pdf_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('format')}</span>
                            <div>A4</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/149a0611.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="hover">
                13.&nbsp;<span className="material-symbols-outlined">mouse</span>&nbsp;{translate('hover')}
            </Typography>
            <p><strong>{translate('hover')}</strong> là hành động di chuột qua phần tử được chỉ định trong trình duyệt.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn di chuột trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>ul.navigate</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="scrapepage">
                14.&nbsp;<span className="material-symbols-outlined">list_alt</span>&nbsp;{translate('scrapepage')}
            </Typography>
            <p><strong>{translate('scrapepage')}</strong> là hành động lấy văn bản hoặc HTML bên trong của tất cả các phần tử khớp với bộ chọn CSS.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và là danh sách văn bản lấy được dưới dạng mảng.</td>
                                <td>$scrape_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn di chuột trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('textonly')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là tuỳ chọn chỉ lấy văn bản trong phần tử, nếu công tắc <strong>{translate('textonly')}</strong> được bật (true) thì kết quả sẽ là văn bản và ngược lại thì kết quả sẽ bao gồm HTML.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$scrape_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>p.season</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(["spring", "summer", "fall", "winter"], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="extractdatafromtable">
                15.&nbsp;<span className="material-symbols-outlined">table</span>&nbsp;{translate('extractdatafromtable')}
            </Typography>
            <p><strong>{translate('extractdatafromtable')}</strong> là hành động lấy văn bản từ một bảng nằm trên trang web.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$extractDataFromTable_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn di chuột trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$extractDataFromTable_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>div.exchange-rate-table</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify([
                                        ["No", "Product Name", "Price"],
                                        [1, "Pen", 200],
                                        [2, "note", 500]
                                    ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="findelement">
                16.&nbsp;<span className="material-symbols-outlined">manage_search</span>&nbsp;{translate('findelement')}
            </Typography>
            <p><strong>{translate('findelement')}</strong> là một hành động cho phép truy xuất phần tử được hiển thị trong trình duyệt theo nhiều cách khác nhau.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$element_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('findelementby')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>
                                    Là phương thức truy xuất phần tử được hiển thị trong trình duyệt.
                                    <ul>
                                        <li>Nếu chọn <strong>{translate('text')}</strong> thì kết quả sẽ là danh sách bộ chọn CSS dưới dạng mảng.</li>
                                        <li>Nếu chọn <strong>{translate('selector')}</strong> thì kết quả sẽ là <i>true</i> hoặc <i>false</i>.</li>
                                    </ul>
                                </td>
                                <td>Text</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản muốn truy xuất trên trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn truy xuất trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                    <br/>
                    <ReturnTypeValue type="boolean" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('findelementby')}</span>
                            <div>Text</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>Sign In</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(["input.signin"], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
                <br />
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('findelementby')}</span>
                            <div>Selector</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>input.signin</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>true</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="geturl">
                17.&nbsp;<span className="material-symbols-outlined">lock</span>&nbsp;{translate('geturl')}
            </Typography>
            <p><strong>{translate('geturl')}</strong> là một hành động lấy URL của trang web bạn đang xem.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getattribute">
                18.&nbsp;<span className="material-symbols-outlined">font_download</span>&nbsp;{translate('getattribute')}
            </Typography>
            <p><strong>{translate('getattribute')}</strong> là một hành động lấy giá trị thuộc tính của phần tử được chỉ định bởi bộ chọn CSS.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn lấy giá trị thuộc tính trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attribute')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là các thuộc tính cần truy xuất như (id, src, href, alt, v.v.).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>img.logo</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('attribute')}</span>
                            <div>src</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://rpa-cloud.io/static/media/logo.c2d9a6453b58088f8c6bb284148a556d.svg</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="waitforselector">
                19.&nbsp;<span className="material-symbols-outlined">hourglass_empty</span>&nbsp;{translate('waitforselector')}
            </Typography>
            <p><strong>{translate('waitforselector')}</strong> là một hành động chờ cho đến khi <strong>{translate('selector')}</strong> xuất hiện trong trang.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn chờ trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('timeout')}</td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là thời gian chờ tối đa được tính bằng phần nghìn giây. Nếu để trống mặc định sẽ là 180000.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>div.bannel</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="draganddrop">
                20.&nbsp;<span className="material-symbols-outlined">move_down</span>&nbsp;{translate('draganddrop')}
            </Typography>
            <p><strong>{translate('draganddrop')}</strong> là một hành động kéo và thả bằng cách chỉ định phần tử được kéo và phần tử được thả.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('targetselector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn kéo trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('destinationselector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là bộ chọn CSS của đối tượng muốn thả trên trình duyệt. Vui lòng xem <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">tại đây</a> để biết cách lấy bộ chọn CSS.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động bỏ qua lỗi, nếu công tắc <strong>{translate('ignoreerror')}</strong> được bật (true) thì trình duyệt vẩn tiếp tục với các hành động tiếp theo ngay cả khi xảy ra lỗi như không tìm thấy bộ chọn CSS.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('targetselector')}</span>
                            <div>div#div1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('destinationselector')}</span>
                            <div>div#div2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="injectjavascript">
                21.&nbsp;<span className="material-symbols-outlined">javascript</span>&nbsp;{translate('injectjavascript')}
            </Typography>
            <p><strong>{translate('injectjavascript')}</strong> là một hành động cho phép bạn thực thi JavaScript bên trong trang.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$injectJavaScript_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('code')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là mã JavaScript.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('code')}</span>
                            <div>
                                let x = 1;<br />
                                let y = 2;<br />
                                return x + y;
                            </div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>3</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gotourl">
                22.&nbsp;<span className="material-symbols-outlined">open_in_browser</span>&nbsp;{translate('gotourl')}
            </Typography>
            <p><strong>{translate('gotourl')}</strong> là một hành động cho phép bạn nhập trực tiếp một URL vào thanh địa chỉ của trình duyệt và thực hiện chuyển đổi. Nó có thể được sử dụng để chuyển tiếp các trang trong khi duy trì phiên hoặc để chuyển đổi ngay lập tức sang các lớp sâu trong trang web bằng cách chỉ định URL.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ của trang web muốn chuyển đổi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động nhấp vào nút của hộp thoại, nếu công tắc <trong>Accept dialog</trong> được bật (true) thì sẽ nhấp vào nút <strong>{translate('signin')}</strong> (xem số ❸ ở phần bổ sung).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>Trường hợp trình duyệt hiện ra hộp thoại.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/signin/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="goback">
                23.&nbsp;<span className="material-symbols-outlined">arrow_back</span>&nbsp;{translate('goback')}
            </Typography>
            <p><strong>{translate('goback')}</strong> là một hành động điều hướng đến trang trước đó trong lịch sử điều hướng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="opennewtab">
                24.&nbsp;<span className="material-symbols-outlined">tab</span>&nbsp;{translate('opennewtab')}
            </Typography>
            <p><strong>{translate('opennewtab')}</strong> là hành động mở một tab/cửa sổ mới trên trình duyệt của bạn.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ của trang web muốn mở.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hành động nhấp vào nút của hộp thoại, nếu công tắc <trong>Accept dialog</trong> được bật (true) thì sẽ nhấp vào nút <strong>{translate('signin')}</strong> (xem số ❸ ở phần bổ sung).</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>Trường hợp trình duyệt hiện ra hộp thoại.</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="switchtab">
                25.&nbsp;<span className="material-symbols-outlined">tab</span>&nbsp;{translate('switchtab')}
            </Typography>
            <p><strong>{translate('switchtab')}</strong> là một hành động điều hướng giữa các tab/cửa sổ đang mở trên trình duyệt của bạn.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('tab')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là vị trí tab bạn muốn di chuyển. Nhập 1 để chỉ định tab cũ nhất. "1", "2", v.v. theo thứ tự các tab được mở. Bạn cũng có thể chỉ định chính đối tượng Tab có thể thu được bằng <strong>{translate('showtabs')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="showtabs">
                26.&nbsp;<span className="material-symbols-outlined">tab_unselected</span>&nbsp;{translate('showtabs')}
            </Typography>
            <p><strong>{translate('showtabs')}</strong> là một hành động truy xuất tất cả các tab/cửa sổ đang mở trên trình duyệt được hiển thị theo thứ tự chúng được mở dưới dạng mảng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này và danh sách các tab/cửa sổ dưới dạng mảng.</td>
                                <td>$tabs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$tabs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            {
                                                "id": 0,
                                                "url": "https://rpa-cloud.io/",
                                                "title": "RPA CLOUD",
                                            }
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="closetab">
                27.&nbsp;<span className="material-symbols-outlined">tab_close</span>&nbsp;{translate('closetab')}
            </Typography>
            <p><strong>{translate('closetab')}</strong> is an act of closing a tab on your browser.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('tab')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là vị trí tab bạn muốn đóng. Nhập 1 để chỉ định tab cũ nhất. "1", "2", v.v. theo thứ tự các tab được mở. Bạn cũng có thể chỉ định chính đối tượng Tab có thể thu được bằng <strong>{translate('showtabs')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>Là hình ảnh được chụp sau khi trình trình duyệt hoàn tất hành động, nếu công tắc <strong>{translate('screenshot')}</strong> được bật (true) thì hình ảnh sẽ được chụp lại và lưu ở kho lưu trữ.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="closebrowser">
                28.&nbsp;<span className="material-symbols-outlined">web_asset_off</span>&nbsp;{translate('closebrowser')}
            </Typography>
            <p><strong>{translate('closebrowser')}</strong> là một hành động đóng mọi tab/cửa sổ đang mở trên trình duyệt của bạn.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là địa chỉ kết nối trình duyệt.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);